import { useSecureAuth } from '~/composables/useSecureAuth'

export default defineNuxtRouteMiddleware((to, from) => {
  if (!process.client) return

  const { getToken } = useSecureAuth()
  const token = getToken()

  if (token) {
    return navigateTo('/admin')
  }
})

